module.exports = __webpack_public_path__ + "media/images/icons/v2/archive-dc030b2533434a30e0044ddbe51a5e66.svg";